<h3>Emails</h3>
<p-table
  id="main-table"
  responsiveLayout="stack"
  breakpoint="640px"
  [value]="_formArray['controls']"
  styleClass="p-datatable-striped"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Email Type</th>
      <th>Email</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-formGroup>
    <tr>
      <td class="email-type-col">
        <span class="p-column-title">Email Type:</span>
        {{ formGroup.get("emailType").value }}
      </td>

      <td class="email-col">
        <span class="p-column-title">Email:</span>
        {{ formGroup.get("email").value }}
      </td>
    </tr>
  </ng-template>
</p-table>
